import classnames from 'classnames';
import {
  GalleryEmbed as V3GalleryEmbed,
  GalleryEmbedProps,
} from '@stadionhq-v3/base-ui';
import styles from './galleryEmbed.module.scss';

const GalleryEmbed = ({ ...props }: GalleryEmbedProps) => {
  const classes = classnames([
    styles.galleryEmbedTokens,
    styles.galleryEmbed,
    props.theme?.themeId ? styles[props.theme.themeId] : styles.default1,
  ]);

  return <V3GalleryEmbed {...props} classNames={[classes]} />;
};

export default GalleryEmbed;
